import { render } from "./BulkSMS.vue?vue&type=template&id=a1b0dda4&scoped=true"
import script from "./BulkSMS.vue?vue&type=script&lang=js"
export * from "./BulkSMS.vue?vue&type=script&lang=js"

import "./BulkSMS.vue?vue&type=style&index=0&id=a1b0dda4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b0dda4"]])

export default __exports__